import { Badge } from '@material-ui/core';
import { AttachFile } from '@material-ui/icons';
import React from 'react';

const withAttachmentsIcons = (WrappedComponent, { attachmentColumnTitle, onClickFunction }) => {
    return class WithAttachmentsIcons extends React.Component {
        
        tableRef = React.createRef();
        
        columns = this.props.columns.map(col => {
            // console.log(attachmentColumnTitle);
            // console.log(this.props);
            if (col.title === attachmentColumnTitle) {

                col.render = (rowData) => (<Badge badgeContent={rowData[col.field].length} color="secondary" showZero><AttachFile></AttachFile></Badge>)
                col.cellStyle = { textAlign: 'left' }
            }
            return col;
        })

        render() {
            return (
                <WrappedComponent tableRef={this.tableRef} {...this.props} {...{ columns: this.columns }} />
            )
        }
    }
}

export default withAttachmentsIcons;